const hasPerm = (perms = {}, key) => !!perms?.[key];

const isAdmin = (perms = {}) => hasPerm(perms, "admin");

export const canAccessItem = ({ item, perms = {}, authUser = {} }) => {
	if (item.blockWhenImpersonating && !!authUser?.isImpersonating) return false;
	if (!item.dismissAdmin && isAdmin(perms)) return true;
	if (item.domainAccess && authUser.checkDomainAccess && !authUser.checkDomainAccess(item.domainAccess)) return false;
	if (!item.permKey) return true;

	const hasPrimary = hasPerm(perms, item.permKey);
	if (hasPrimary) return true;

	if (item.permKeyAlt) {
		return hasPerm(perms, item.permKeyAlt);
	}

	return false;
};

export const filterSectionItems = ({ section, perms = {}, authUser = {} }) => {
	if (!section?.items?.length) return [];
	return section.items.filter((item) => canAccessItem({ item, perms, authUser }));
};

export const getVisibleSections = ({ sections = [], perms = {}, authUser = {} }) => {
	return sections
		.map((section) => ({
			...section,
			items: filterSectionItems({ section, perms, authUser })
		}))
		.filter((section) => section.items.length > 0);
};

export const getVisiblePinnedItems = ({ pinnedItems = [], perms = {}, authUser = {} }) => {
	return pinnedItems.filter((item) => canAccessItem({ item, perms, authUser }));
};

export const buildNavAccess = ({ navConfig = {}, perms = {}, authUser = {} }) => {
	return {
		sections: getVisibleSections({ sections: navConfig.sections, perms, authUser }),
		pinnedItems: getVisiblePinnedItems({ pinnedItems: navConfig.pinnedItems, perms, authUser })
	};
};
